<template>
  <div :class="classes()">
    <MetaNav
      :open="mainNavOpen"
      @toggleMobileNavigation="toggleNav"
      :onlyLogoutLink="!!$route.meta.hideMainNav"
    />

    <template v-if="!$route.meta.hideMainNav">
      <MainNav
        :isOpen="mainNavOpen"
        @toggleNav="toggleNav"
        :navItems="[
          nav($t('mainNav.item.overview'), routes.ROUTE_DASHBOARD, 'home-line'),
          nav($t('mainNav.item.taskScheduler'), routes.ROUTE_TASK_SCHEDULER, 'survey-line'),
          {
            ...nav(
              $t('mainNav.item.service'),
              routes.ROUTE_SERVICE_CARELEVEL_CALCULATOR_WIZARD,
              'service-line'
            ),

            subNavItem: [
              nav(
                $t('mainNav.item.service.careLevel'),
                routes.ROUTE_SERVICE_CARELEVEL_CALCULATOR_WIZARD,
                undefined,
                false
              ),
              nav(
                $t('mainNav.item.service.careService'),
                routes.ROUTE_SERVICE_PFLEGELEISTUNGSFINDER
              ),
              /*nav(
                $t('mainNav.item.service.burdonScaleForFamilyCaregivers'),
                routes.ROUTE_SERVICE_BURDEN_SCALE_FOR_FAMALY_CAREGIVERS
              ),
              {
              ...nav('Weitere Hilfen', '#'),
              subNavItem: [
                nav('Weitere Hilfen Sub 1', '#'),
                nav('Weitere Hilfen Sub 2', '#', undefined, true),
                nav('Weitere Hilfen Sub 3', '#'),
              ],
            },*/
            ],
          },
          {
            ...nav($t('mainNav.item.analyses'), routes.ROUTE_ANALYSE_CARE_LEVEL, 'pie-chart-line'),

            subNavItem: [
              nav($t('mainNav.item.analyses.careLevel'), routes.ROUTE_ANALYSE_CARE_LEVEL),
              nav($t('mainNav.item.analyses.careService'), routes.ROUTE_ANALYSE_CARE_SERVICE),
              /*nav(
                $t('mainNav.item.analyses.burdonScaleForFamilyCaregivers'),
                routes.ROUTE_ANALYSE_BURDEN_SCALE_FOR_FAMALY_CAREGIVERS
              ),*/
            ],
          },
          nav($t('mainNav.item.applications'), routes.ROUTE_APPLICATIONS, 'file-list-2-line'),
          nav($t('mainNav.item.careProfiles'), routes.ROUTE_CARE_PROFILES, 'folder-user-line'),
        ]"
      />
      <div :class="`${el}__content`">
        <Container>
          <slot />
          <Footer />
        </Container>
      </div>
    </template>

    <div v-else>
      <div :class="`${el}__content ${el}__content--full`">
        <slot />
        <Footer />
      </div>
    </div>

    <Modal
      size="s"
      :headline="$t('careLevelModal.headline')"
      :open="showCareLevelModal"
      @close="closeModal"
      overflow
    >
      <CareLevelForm
        v-if="showCareLevelModal"
        isSendable
        :defaultCareLevel="careLevelSituation === 0 ? careLevel : null"
        :defaultCareLevelDate="careLevelSituation === 0 ? careLevelDate : null"
        @trackingLinkClicked="trackClick"
        careLevelIsResettable
      />
    </Modal>
    <CareLevelAnalysisModal v-if="unregisteredUuid !== null" />

    <FeedbackLayer />
  </div>
</template>

<script>
import Container from '@/objects/Container';
import MainNav from '@/components/MainNav';
import MetaNav from '@/components/MetaNav';
import Footer from '@/components/Footer';
import Modal from '@/components/Modal';
import FeedbackLayer from '@/components/FeedbackLayer';
import { CareLevelForm } from '@/components/CareLevelChecker';
import CareLevelAnalysisModal from '@/components/CareLevelAnalysisModal/';

import {
  ROUTE_INTRO,
  ROUTE_DASHBOARD,
  ROUTE_SERVICE_CARELEVEL_CALCULATOR_WIZARD,
  ROUTE_SERVICE_PFLEGELEISTUNGSFINDER,
  ROUTE_SERVICE_BURDEN_SCALE_FOR_FAMALY_CAREGIVERS,
  ROUTE_TASK_SCHEDULER,
  ROUTE_ANALYSE_CARE_LEVEL,
  ROUTE_ANALYSE_CARE_SERVICE,
  ROUTE_ANALYSE_BURDEN_SCALE_FOR_FAMALY_CAREGIVERS,
  ROUTE_APPLICATIONS,
  ROUTE_CARE_PROFILES,
} from '@/constants/routes';

import { LS_MAIN_NAV_OPEN } from '@/constants/storage';
import { HEALTH_TOGGLE_CARE_LEVEL_MODAL } from '@/store/actions/health';
import { TASKS_UPDATE_CURRENT_TASK } from '@/store/actions/tasks';

import { mapFieldsHealth } from '@/store/mapFields';
import { createTrackingData } from '@/helpers/tracking/utils/helpers';

export default {
  name: 'DashboardWrapper',
  props: {},
  components: {
    CareLevelAnalysisModal,
    Container,
    MetaNav,
    MainNav,
    Footer,
    Modal,
    FeedbackLayer,
    CareLevelForm,
  },
  computed: {
    ...mapFieldsHealth([
      'healthDataLoaded',
      'dependentPerson',
      'showCareLevelModal',
      'unregisteredUuid',
      'careLevelSituation',
      'careLevelDate',
      'careLevel',
    ]),
  },
  watch: {
    $route() {
      this.redirectToIntroIfNecessary();
      if (!this.$matchMedia.l && this.mainNavOpen) {
        this.mainNavOpen = false;
      }
    },

    healthDataLoaded() {
      this.redirectToIntroIfNecessary();
    },

    '$matchMedia.xl': function () {
      this.mainNavOpen = this.$matchMedia.xl;
    },
  },
  data() {
    const lsNav = localStorage.getItem(LS_MAIN_NAV_OPEN);

    return {
      routes: {
        ROUTE_DASHBOARD,
        ROUTE_SERVICE_CARELEVEL_CALCULATOR_WIZARD,
        ROUTE_SERVICE_PFLEGELEISTUNGSFINDER,
        ROUTE_SERVICE_BURDEN_SCALE_FOR_FAMALY_CAREGIVERS,
        ROUTE_TASK_SCHEDULER,
        ROUTE_ANALYSE_CARE_LEVEL,
        ROUTE_ANALYSE_CARE_SERVICE,
        ROUTE_ANALYSE_BURDEN_SCALE_FOR_FAMALY_CAREGIVERS,
        ROUTE_APPLICATIONS,
        ROUTE_CARE_PROFILES,
      },
      mainNavOpen: this.$matchMedia.xl ? lsNav === null || JSON.parse(lsNav) : false,
      el: 'c-dashboardWrapper',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--mainNavOpen is-mainNavOpen`]: this.mainNavOpen,
          'is-dashboard': true,
        };
      },
    };
  },
  created() {
    if (this.unregisteredUuid) {
      if (this.careLevelSituation === 2) {
        /**
         * Es besteht kein Pflegegrad, aber der
         * Wizard wurde bereits durchlaufen.
         */
        this.$store.dispatch(TASKS_UPDATE_CURRENT_TASK, 'P2-20');
      } else {
        /**
         * Wenn Pflegegrad vorhanden: P3-20 -> this.careLevelSituation === 0
         * Wenn Pflegegrad beantragt: P2-30 -> this.careLevelSituation === 1
         * Wenn kein Pflegegrad: P1-10 -> this.careLevelSituation === 2
         */

        const taskID = this.careLevelSituation === 0 ? 'P3-20' : 'P2-40';

        this.$store.dispatch(TASKS_UPDATE_CURRENT_TASK, taskID);
      }
    }
  },
  mounted() {
    this.redirectToIntroIfNecessary();
  },
  methods: {
    redirectToIntroIfNecessary() {
      /**
       * Wenn das Intro noch nicht durchlaufen wurde,
       * dann leite zurück ins Intro.
       * Der Fall tritt logisch nie auf. Aber wer weiß...
       */
      if (
        this.healthDataLoaded &&
        this.dependentPerson === null &&
        !this.$router.currentRoute.path.includes(ROUTE_INTRO)
      ) {
        this.$router.push(ROUTE_INTRO);
      }
    },

    toggleNav() {
      this.mainNavOpen = !this.mainNavOpen;
      if (this.$matchMedia.l) {
        localStorage.setItem(LS_MAIN_NAV_OPEN, this.mainNavOpen);
      }
    },
    nav(text, to, iconName, isNew = false) {
      const obj = {
        text,
        to,
        isNew,
        active: this.$route.path.includes(to),
      };
      if (iconName) {
        obj.iconName = iconName;
      }
      return obj;
    },

    closeModal() {
      this.trackClick('click-schließen', 'element');
      this.$store.dispatch(HEALTH_TOGGLE_CARE_LEVEL_MODAL);
    },

    trackClick(labelText, element) {
      let product = '';
      let mode = '';

      switch (this.$route.name) {
        case 'Dashboard':
          product = 'Dashboard';
          break;
        case 'CareProfiles':
          product = 'Pflegeprofil';
          break;
        case 'PflegeleistungenAnalysis':
          product = 'Pflegeleistungsanalyse';
          mode = '-ohne-Pflegegrad';
          break;
      }

      const label = product + mode + '-Anpassung-PG-Pop-up_' + labelText;

      createTrackingData(product, label, element);
    },
  },
};
</script>
